import styled from "styled-components/macro";
import {WindowSizePXEnum} from "../../../../../interface/Basic/window";

export const BoxIsolatedContentAdmin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  @media (max-width: ${WindowSizePXEnum.xxs}) {
    max-height: 400px;
  }
`

export const LoginAdminHeader = styled.div`
  display: flex;
  align-items: center;
  margin-left: 60px;
`

export const LoginAdminInfo =  styled.div`
  width: 100%;
  margin-top: 10px;
  background-color: #EBF4FF;
  display: flex;
  alignItems: center;
  justify-content: start;
  padding: 12px 24px;
  gap: 8px
`

export const LoginAdminAccount = styled.div`
  width: 100%;
  padding: 24px 24px 4px;
  display: flex;
  flex-direction: column;
  gap: 12px
`
export const LoginAdminEmail = styled.div`
  width: 100%;
  padding: 4px 24px 24px;
  display: flex;
  justify-content: space-between
`

export const Border = styled.div`
  width: 90%;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
`
export const SelectedUserBlock = styled.div`
  position: relative;
  height: 56px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`
export const AccountSelectBlock = styled.div`
  position: relative;
  height: 56px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  align-items: center;
  display: flex;
  cursor: pointer;
`
export const SelectedUserContent = styled.div`
  padding: 7px 16px;
  display: flex;
  gap: 2px;
  flex-direction: column;
  align-items: start;
`
export const InputIconContainer = styled.div`
  margin-right: 16px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

export const Padding24Width100 = styled.div`
  padding: 0 24px;
  width: 100%;
`